/* Olympiamagazin: YouTube-Videos nur mit Einwilligung (Jan, 22.09.).
   - In Blogbeiträgen wird aus einem YouTube-Link, der allein in einer Zeile steht, ein Video-Platzhalter.
     Eingefügter YouTube-Einbettungscode (iframe) wird in sections/main-article.liquid vorab entschärft
     (<olympia-iframe>) und hier ebenfalls zum Platzhalter.
   - Hat der Besucher im Cookie-Banner „Marketing“ erlaubt, lädt das Video direkt (youtube-nocookie.com).
   - Sonst zeigt der Platzhalter einen Hinweis; ein Klick auf „Video abspielen“ lädt genau dieses Video.
   - Vorher geht keine Anfrage an YouTube/Google (auch kein Vorschaubild). */
(function () {
  var RE = /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#\s]*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/i;
  var PRIVACY_URL = '/pages/datenschutzerklaerung';
  var allowed = false;
  var boxes = [];

  function videoId(url) {
    var m = RE.exec(url || '');
    return m ? m[1] : null;
  }

  function load(box, autoplay) {
    if (box.classList.contains('is-loaded')) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + box.dataset.ytId + '?rel=0' + (autoplay ? '&autoplay=1' : '');
    f.title = box.dataset.ytTitle || 'YouTube-Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.setAttribute('allowfullscreen', '');
    f.loading = 'lazy';
    box.innerHTML = '';
    box.appendChild(f);
    box.classList.add('is-loaded');
  }

  function makeBox(id, title) {
    var box = document.createElement('div');
    box.className = 'olympia-yt';
    box.dataset.ytId = id;
    if (title) box.dataset.ytTitle = title;
    box.innerHTML =
      '<div class="olympia-yt__inner">' +
        '<button type="button" class="olympia-yt__play" aria-label="Video abspielen">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>' +
        '</button>' +
        '<p class="olympia-yt__label">Video abspielen</p>' +
        '<p class="olympia-yt__note">Mit dem Klick wird das Video von YouTube geladen. Dabei werden Daten an Google übertragen. ' +
        'Mehr in der <a href="' + PRIVACY_URL + '">Datenschutzerklärung</a>. ' +
        'Videos immer direkt laden: <a href="#cookie-einstellungen" data-cookie-einstellungen>Cookie-Einstellungen</a>.</p>' +
      '</div>';
    box.querySelector('.olympia-yt__play').addEventListener('click', function () { load(box, true); });
    boxes.push(box);
    if (allowed) load(box, false);
    return box;
  }

  function scan(root) {
    root = root || document;
    // Entschärfte Einbettungscodes aus Blogbeiträgen
    root.querySelectorAll('olympia-iframe').forEach(function (el) {
      var src = el.getAttribute('src') || el.getAttribute('data-src') || '';
      var id = videoId(src);
      if (id) {
        el.replaceWith(makeBox(id, el.getAttribute('title')));
      } else {
        // Kein YouTube: normales iframe wiederherstellen
        var f = document.createElement('iframe');
        Array.prototype.forEach.call(el.attributes, function (a) { if (a.name !== 'hidden') f.setAttribute(a.name, a.value); });
        el.replaceWith(f);
      }
    });
    // YouTube-Link allein in einer Zeile (als Link oder als reiner Text)
    root.querySelectorAll('.article-template__content p').forEach(function (p) {
      var text = p.textContent.trim();
      var id = null;
      var links = p.querySelectorAll('a');
      if (links.length === 1 && links[0].textContent.trim() === text) id = videoId(links[0].href);
      else if (!links.length && /^https?:\/\/\S+$/.test(text)) id = videoId(text);
      if (id) p.replaceWith(makeBox(id));
    });
  }

  function setAllowed(value) {
    allowed = !!value;
    if (allowed) boxes.forEach(function (b) { load(b, false); });
  }

  function readConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.marketingAllowed === 'function') setAllowed(cp.marketingAllowed());
  }

  document.addEventListener('visitorConsentCollected', function (e) {
    setAllowed(e.detail && e.detail.marketingAllowed);
  });

  function start() {
    scan(document);
    readConsent();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) readConsent();
      });
    }
  }

  window.olympiaYouTube = { scan: scan, load: load };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
